module.exports = __webpack_public_path__ + "static/media/400098_02.0b094a58.png";